import { renderLearningCenter } from './learning-center.js';
import { createGuidedTour } from './guided-tour.js';
import { TUTORIALS } from './tutorial-content.js';
export { TUTORIALS } from './tutorial-content.js';

export function progressKey(uid, tutorial) { return `rv_guide_${uid || 'guest'}_${tutorial.id}_v${tutorial.version}`; }

export function createTutorialSystem({ storage, uid, navigate, clanPanel, currentTab, document: doc = document }) {
  let running = null, current = null, sequence = Promise.resolve(), launch = 0;
  const visible = selector => { const el = doc.querySelector(selector); return !!el?.getClientRects().length; };
  const read = async g => { try { return JSON.parse(await storage.get(progressKey(uid(),g)) || '{}'); } catch { return {}; } };
  const save = (key, value) => { sequence = sequence.catch(() => {}).then(() => storage.set(key, JSON.stringify(value))); };
  function context() {
    for (const [id, selector] of [['notifications','#notification-modal'],['universe','#universe-gate'],['card-detail','#card-modal']]) {
      const el=doc.querySelector(selector);
      if (visible(selector) && (el?.classList.contains('open') || el?.classList.contains('active') || el?.classList.contains('show') || el?.getAttribute('aria-hidden') === 'false')) return id;
    }
    if (currentTab()==='arena' && visible('#battle-my-row')) return 'battle';
    if (currentTab()==='clan') {
      const panel=doc.querySelector('.clan-panel.active');
      if (panel) return `clan-${panel.id.replace('cpanel-','')}`;
    }
    return currentTab();
  }
  async function start(id, restart=false) {
    const ticket=++launch;
    const g=TUTORIALS.find(g=>g.id===id); if(!g) return;
    running?.close('replace');
    // A battle or modal guide only runs on its real screen; never open paid actions.
    const transient=['battle','card-detail','universe','notifications','player-profile'].includes(id);
    if(transient && !visible(g.steps[0].selector)) return;
    if(!transient) { await navigate(g.tab); if(g.panel) await clanPanel(g.panel); }
    await sequence.catch(() => {});
    const saved=await read(g), key=progressKey(uid(),g); let index=restart||saved.status==='complete'?0:saved.index||0;
    if(ticket!==launch || (!transient && currentTab()!==g.tab) || (transient && !visible(g.steps[0].selector))) return;
    current=g;
    const completed=saved.status==='complete';
    running=createGuidedTour({onStep: n=>{index=n;save(key,{index,status:completed?'complete':'started'});},onClose: reason=>{
      save(key,{index,status:completed||reason==='complete'?'complete':'paused'});
      running=null; current=null;
    }});
    running.open(g.steps.map(s => ({...s, interactive: false})),index);
  }
  async function center() {
    const ticket=++launch;
    running?.close('navigation');
    const here=context(); await navigate('help');
    await sequence.catch(() => {});
    const states=await Promise.all(TUTORIALS.map(read));
    if(ticket!==launch || currentTab()!=='help') return;
    const root=doc.getElementById('tutorial-center'); if(!root) return;
    renderLearningCenter({root,states,here,start,reopen:center,complete:async g=>{
      save(progressKey(uid(),g),{index:g.steps.length-1,status:'complete'});await center();
    }});
  }
  function close(){running?.close('navigation');}
  function help(){const id=context(); if(TUTORIALS.some(g=>g.id===id))return start(id);return center();}
  return {start,center,help,close,context,next:()=>running?.next(),prev:()=>running?.prev(),get active(){return current;}};
}
